export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const setSearchTerm = searchTerm => ({
    type: SET_SEARCH_TERM,
    searchTerm,
});

export const RESET_SEARCH_TERM = 'RESET_SEARCH_TERM';
export const resetSearchTerm = () => ({
    type: RESET_SEARCH_TERM,
});
